var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSigninGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2679_7941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2273 14.3223C28.2273 13.3706 28.1501 12.4138 27.9855 11.4775H14.7803V16.8687H22.3423C22.0285 18.6074 21.0202 20.1456 19.5438 21.123V24.621H24.0553C26.7046 22.1827 28.2273 18.5817 28.2273 14.3223Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7803 28.0009C18.5561 28.0009 21.7404 26.7611 24.0605 24.6211L19.549 21.1231C18.2938 21.977 16.6734 22.4606 14.7854 22.4606C11.133 22.4606 8.0362 19.9965 6.92505 16.6836H2.26953V20.2897C4.64616 25.0172 9.48688 28.0009 14.7803 28.0009Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9199 16.6837C6.33346 14.9449 6.33346 13.0621 6.9199 11.3234V7.71729H2.26953C0.283856 11.6732 0.283856 16.3339 2.26953 20.2898L6.9199 16.6837Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7803 5.54127C16.7762 5.51041 18.7053 6.26146 20.1508 7.64012L24.1479 3.64305C21.6169 1.26642 18.2578 -0.0402103 14.7803 0.000943444C9.48687 0.000943444 4.64616 2.98459 2.26953 7.71728L6.91991 11.3234C8.02591 8.00536 11.1279 5.54127 14.7803 5.54127Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2679_7941"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigninGoogle);
export default __webpack_public_path__ + "static/media/Signin-Google.50fe714796d44b4c2e0e3b1c4b0f545c.svg";
export { ForwardRef as ReactComponent };